import { Snackbar, Alert, Slide } from '@mui/material';
import _ from 'lodash';
import { memo, useState } from 'react';
import { removeSnackbar } from '../../store/features/snackbar/snackbarSlice';
import { SnackbarStateItem } from '../../store/features/snackbar/types';
import { useAppDispatch } from '../../store/hooks';
import { snackbarStackStyles } from './styles';

interface SnackbarStackItemProps {
  snackbar: SnackbarStateItem;
}

const SnackbarStackItemComponent: React.FC<SnackbarStackItemProps> = ({ snackbar: { severity, message, id } }) => {
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => {
    setIsOpen(false);
    _.delay(() => dispatch(removeSnackbar(id)), 300); // This delay is added to wait for transition to finish
  };
  return (
    <Snackbar
      ClickAwayListenerProps={{ onClickAway: () => ({}) }} // This props has been set so that click away does not remove this component
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
      open={isOpen}
      sx={snackbarStackStyles.stackItem}
      autoHideDuration={15000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};
export const SnackbarStackItem = memo(SnackbarStackItemComponent);
